define('glu/flexDropdown/views/flexDropdownSelectionView',['require','../../itemView','hbs!./flexDropdownSelectionView.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView');

    return ItemView.extend({
        noDefaultBehaviors: true,
        noGluEvents: true,
        template: require('hbs!./flexDropdownSelectionView.hbs'),
        tagName: 'li',

        templateHelpers: function() {
            return {
                showWithCancelIcon: this.options.clearBtn && this.options.showCancelIcon
            };
        }
    });
});

